/*

一般公開ページ全体の共通JS
が記述されています

*/

const { runInContext } = require("lodash");


//アコーディオンメニュー　トップページ
$(function () {
  $('.accordion').click(function () {
    $(this).toggleClass('active');
    $(this).next('.accordion-wrapper').slideToggle();
  });
});
$(function () {
  $('.accordion2').click(function () {
    $(this).toggleClass('active');
    $(this).next('.accordion-wrapper2').slideToggle();
  });
});

//星評価　Jquery Raty.js
$('.jq-stars0').raty({
  readOnly: true,
  score: 0,
  path: '/assets/images/',
});
$('.jq-stars0-5').raty({
  readOnly: true,
  score: 0.5,
  path: '/assets/images/',
});
$('.jq-stars1').raty({
  readOnly: true,
  score: 1,
  path: '/assets/images/',
});
$('.jq-stars1-5').raty({
  readOnly: true,
  score: 1.5,
  path: '/assets/images/',
});
$('.jq-stars2').raty({
  readOnly: true,
  score: 2,
  path: '/assets/images/',
});
$('.jq-stars2-5').raty({
  readOnly: true,
  score: 2.5,
  path: '/assets/images/',
});
$('.jq-stars3').raty({
  readOnly: true,
  score: 3,
  path: '/assets/images/',
});
$('.jq-stars3-5').raty({
  readOnly: true,
  score: 3.5,
  path: '/assets/images/',
});
$('.jq-stars4').raty({
  readOnly: true,
  score: 4,
  path: '/assets/images/',
});
$('.jq-stars4-5').raty({
  readOnly: true,
  score: 4.5,
  path: '/assets/images/',
});
$('.jq-stars5').raty({
  readOnly: true,
  score: 5,
  path: '/assets/images/',
});

//いいね　トップページ
$(function () {
  $('.like').click(function () {
    let isMemberLogin = $(this).hasClass('js_modal_open4');
    if (isMemberLogin) {
    }
    else{
      $(this).toggleClass('active');
    }
  });
});

//お気に入り　店舗一覧ページ
$(function () {
  $('.follow').click(function () {
    let isMemberLogin = $(this).hasClass('js_modal_open4');
    if (isMemberLogin) {
    }
    else{
      $(this).toggleClass('active');
    }
  });
});

// //コラム一覧ページ　ページャー
// $(function() {
//   $('.recommend-column-wrapper').paginathing({//親要素のclassを記述
//     perPage: 13,//1ページあたりの表示件数
//     prevNext: false,
//     activeClass: 'navi-active',//現在のページ番号に任意のclassを付与できます
//     firstText:'',
//     lastText:'',
//   })
// });

// //お知らせ一覧ページ　ページャー
// $(function() {
//   $('.information-wrapper').paginathing({//親要素のclassを記述
//     perPage: 10,//1ページあたりの表示件数
//     prevNext: false,
//     activeClass: 'navi-active',//現在のページ番号に任意のclassを付与できます
//     firstText:'',
//     lastText:'',
//   })
// });

//店舗一覧ページ　ページャー
// $(function() {
//   $('.shop-list-pagination').paginathing({//親要素のclassを記述
//     perPage: 10,//1ページあたりの表示件数
//     prevNext: false,
//     activeClass: 'navi-active',
//     firstText:'',
//     lastText:'',
//   })
// });
//店舗一覧ページ　写真一覧 ページャー
// $(function() {
//   $('.photos-list-pagination').paginathing({//親要素のclassを記述
//     perPage: 60,//1ページあたりの表示件数
//     prevNext: false,
//     activeClass: 'navi-active',
//     firstText:'',
//     lastText:'',
//   })
// });

//fes一覧ページ　ページャー
// $(function() {
//   $('.fes-list-pagination').paginathing({//親要素のclassを記述
//     perPage: 10,//1ページあたりの表示件数
//     prevNext: false,
//     activeClass: 'navi-active',
//     firstText:'',
//     lastText:'',
//   })
// });

// //レビュー一覧ページ　ページャー
// $(function() {
//   $('.reviews-pagination').paginathing({//親要素のclassを記述
//     perPage: 10,//1ページあたりの表示件数
//     prevNext: false,
//     activeClass: 'navi-active',
//     firstText:'',
//     lastText:'',
//   })
// });






//レビュー編集　モーダルウィンドウ
$(".js_modal_open").click(function () {

  $(".edit-modal").fadeIn();
  $(".edit-modal").css("display", "flex");
  $('body').css('overflow-y', 'hidden');

});
$(".edit-modal .modal .close").click(function () {
  $(".edit-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});
$(".edit-modal .modal #edit-cancel").click(function () {
  $(".edit-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});


//レビュー投稿　モーダルウィンドウ
$(".js_modal_open2").click(function () {

  $(".post-modal").fadeIn();
  $(".post-modal").css("display", "flex");
  $('body').css('overflow-y', 'hidden');

});
$(".post-modal .modal .close").click(function () {
  $(".post-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});
$(".post-modal .modal #post-cancel").click(function () {
  $(".post-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});


//食べたボタンログイン前　モーダルウィンドウ
$(".js_modal_open4").click(function (event) {
  event.preventDefault();
  $(".ate-modal").fadeIn();
  $(".ate-modal").css("display", "flex");
  $('body').css('overflow-y', 'hidden');

});
$(".ate-modal .modal .close").click(function (event) {
  event.preventDefault();
  $(".ate-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});
$(".ate-modal .modal #register-cancel").click(function () {
  $(".ate-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});

// 店舗詳細ページ　SP　タブ切り替え
/*
$(window).resize(function () {
  console.log('window resize!');
  if (window.matchMedia("(max-width: 768px)").matches) {
    $('.tab_box .tab_btn').click(function () {
      var index = $('.tab_box .tab_btn').index(this);
      $('.tab_box .tab_btn, .tab_box .tab_panel').removeClass('active');
      $(this).addClass('active');
      $('.tab_box .tab_panel').eq(index).addClass('active');
    });
  }
});
*/
$(function() {
  $('.tab_box .tab_btn').click(function () {
    var index = $('.tab_box .tab_btn').index(this);
    $('.tab_box .tab_btn, .tab_box .tab_panel').removeClass('active');
    $(this).addClass('active');
    $('.tab_box .tab_panel').eq(index).addClass('active');
  });
});

//食べたボタン　ログイン前　モーダルウィンドウ
$(".js_modal_open4").click(function () {

  $(".ate-modal").fadeIn();
  $(".ate-modal").css("display", "flex");
  $('body').css('overflow-y', 'hidden');

});
$(".ate-modal .modal .close").click(function () {
  $(".ate-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});
$(".ate-modal .modal #register-cancel").click(function () {
  $(".ate-modal").css("display", "none");
  $('body').css('overflow-y', 'auto');
});
// $(".js_modal_open4").click(function () {

//   $(".ate-modal").fadeIn();
//   $(".ate-modal").css("visibility", "visible");
//   $('body').css('overflow-y', 'hidden');

// });
// $(".ate-modal .modal .close").click(function () {
//   $(".ate-modal").css("visibility", "hidden");
//   $('body').css('overflow-y','auto');
// });
// $(".ate-modal .modal #register-cancel").click(function () {
//   $(".ate-modal").css("visibility", "hidden");
//   $('body').css('overflow-y','auto');
// });




//店舗詳細ページ　店舗の紹介文　続きを読む
if (window.matchMedia("(max-width: 650px)").matches) {
  $(function () {
    var textHeight = $('.shop-detail-txt').height();
    var lineHeight = parseFloat($('.shop-detail-txt').css('line-height'));
    var lineNum = 3;
    var textNewHeight = lineHeight * lineNum;

    if (textHeight > textNewHeight) {
      $('.shop-detail-txt').css({
        'height': textNewHeight,
        'overflow': 'hidden'
      });
      $('.readmore-btn-sp').show();
      $('.readmore-btn-sp').click(function () {
        $(this).hide();
        $('.shop-detail-txt').css({
          'height': textHeight,
          'overflow': 'visible'
        });
        return false;
      });
    };
  });
} else {
}


//出店経歴　5件以上でもっと見る　
$(function () {
  var hideList = '.fes-record .tag:nth-of-type(n+6)';
  $(hideList).hide();
  $('.more-fes').click(function () {
    $(hideList).toggle();
    if ($(hideList).css('display') == 'none') {
      $('.more-fes').text('もっと見る');
    } else {
      $('.more-fes').text('閉じる');
    }
    return false;
  });

  var num = $('.fes-record').children('.tag').length;
  if (num < 6) {
    $('.more-fes').hide();
  };
});

$(function () {
  /*
  * バリデーションエラー表示
  * errors - JSON形式のエラーメッセージ
  */
  showValidationErrors = function (errors) {
    // エラー表示追加
    $('.form-error ul li').remove();
    for (let i in errors) {
      $('.form-error ul').append('<li>' + errors[i] + '</li>');
    }
    // 表示
    $('.form-error').removeClass('d-none');
  };

});
